import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Tables = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.5 2H3C2.44772 2 2 2.44772 2 3V5.5H5.5V2ZM5.5 1H6.5H9.5H10.5H13C14.1046 1 15 1.89543 15 3V5.5V6.5V9.5V10.5V13C15 14.1046 14.1046 15 13 15H10.5H9.5H6.5H5.5H3C1.89543 15 1 14.1046 1 13V10.5V9.5V6.5V5.5V3C1 1.89543 1.89543 1 3 1H5.5ZM2 10.5V13C2 13.5523 2.44772 14 3 14H5.5V10.5H2ZM5.5 9.5H2V6.5H5.5V9.5ZM6.5 10.5V14H9.5V10.5H6.5ZM9.5 9.5H6.5V6.5H9.5V9.5ZM10.5 10.5V14H13C13.5523 14 14 13.5523 14 13V10.5H10.5ZM14 9.5H10.5V6.5H14V9.5ZM6.5 2H9.5V5.5H6.5V2ZM10.5 2V5.5H14V3C14 2.44772 13.5523 2 13 2H10.5Z"
        fill={color}
      />
    </svg>
  )
})

export default Tables
